import React, { useContext } from "react";

import { FeedbackHeader } from "./FeedbackHeader";
import { Typography } from "@/components/Typography";
import { StarsRating } from "@/components/StarsRating";

import { FEEDBACK_PREVIEW_INDEX } from "@/utils/feedbackPreviewNavigation";

import { QRFeedbackContextProps } from "@/contexts/QRFeedbackContext/types";
import { QRFeedbackContext } from "@/contexts/QRFeedbackContext";

import { MultipleFeedbackProps } from "./types";
import { QRFeedbackReviewCategory } from "@/types/qr";

export const MultipleFeedback = ({ data }: MultipleFeedbackProps) => {
  const qrFeedbackContextData = useContext<QRFeedbackContextProps>(QRFeedbackContext);
  const { setSelectedReviewCategoryIndex, feedbackReviewData, setRatingSelected, setCurrentView } =
    qrFeedbackContextData;
  const { categories } = feedbackReviewData;

  const handler = (item: QRFeedbackReviewCategory, indx: number) => {
    setRatingSelected(item.rating);
    setSelectedReviewCategoryIndex(indx);
    setCurrentView(FEEDBACK_PREVIEW_INDEX.MULTIPLE_CATEGORIES_FORM);
  };
  return (
    <div className="feedback-template__multiple">
      <FeedbackHeader data={data} />
      <div className="feedback-template__category-list">
        {categories?.map((category, i) => {
          return (
            <div
              key={i}
              className="feedback-template__category-item"
              onClick={() => handler(category, i)}
            >
              <div className="item-name">
                <Typography
                  Tag="p"
                  classname="u-semibold u-spacing-4"
                >
                  {category.name}
                </Typography>
              </div>
              {category.rating && (
                <div className="item-rating">
                  <StarsRating
                    itemIndex={i}
                    defaultCheckedValue={category.rating}
                    compact
                  />
                </div>
              )}
              <span className="chevron right"></span>
            </div>
          );
        })}
      </div>
    </div>
  );
};
